import { createInternalComponent, useTranslation } from "@opendash/core";
import { Divider, Input, Modal } from "antd";
import * as React from "react";
import styled from "styled-components";
import {
  WidgetPresetInterface,
  useMonitoringService,
  useWidgetPresets,
} from "..";
import WidgetPresetComponent from "./WidgetPresetComponent";

const CARD_WIDTH = 300;
const CARD_GUTTER = 10;

const CardList = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: left;
  align-items: flex-start;
  height:80%
  gap: ${CARD_GUTTER}px;
`;

const CardListItem = styled.div`
  width: ${CARD_WIDTH}px;

  img {
    padding: 2px 1px;
  }

  .ant-card-body {
    padding: 12px;
  }
`;

interface Props {
  open: boolean;
  close: () => void;
  limit?: number;
  onSave?: (presets: WidgetPresetInterface[]) => void;
}

export const WidgetCreationModal = createInternalComponent<Props>(
  function WidgetCreationModal({ open, close, limit = 1, onSave }) {
    const t = useTranslation();
    const MonitoringService = useMonitoringService();
    const presets = useWidgetPresets();
    const presetTagOrder = [
      "H&G",
      "kpi",
      "charttime",
      "chartstate",
      "pivot",
      "geo",
      "control",
    ];
    const [selection, setSelection] = React.useState([]);
    const [filter, setFilter] = React.useState("");
    React.useEffect(() => {
      if (!open) {
        setSelection([]);
      }
    }, [open]);

    const modalWidth = new Array(5)
      .fill(0)
      .map((_, i) => i * (CARD_WIDTH + CARD_GUTTER * 2) + CARD_WIDTH + 48 + 10) // 48 = modal padding
      .reverse()
      .find((width) => width < window.innerWidth - 40);

    const getGroupedPresets: Record<string, WidgetPresetInterface[]> =
      React.useMemo(() => {
        const groups: Record<string, WidgetPresetInterface[]> = {};
        presets.forEach((preset) => {
          //let groupKey = preset.widget.type.split("-")[2];

          (preset.tags || []).forEach((tag) => {
            const groupKey = tag;
            const group = groups[groupKey] || [];
            group.push(preset);
            groups[groupKey] = group;
          });

          if ((preset.tags?.length || 0) == 0) {
            const groupKey = "_other";
            const group = groups[groupKey] || [];
            group.push(preset);
            groups[groupKey] = group;
          }
        });

        return Object.keys(groups)
          .sort()
          .reverse()
          .reduce(
            (acc, key) => ({
              ...acc,
              [key]: groups[key],
            }),
            {}
          );
      }, [presets]);

    return (
      <Modal
        title={t("opendash:widgets.catalogue.title")}
        okText={t("opendash:ui.close")}
        open={open}
        width={modalWidth}
        cancelButtonProps={{ style: { display: "none" } }}
        onCancel={(e) => close()}
        onOk={() => {
          /*
          const selectedPresets: WidgetPresetInterface[] = selection.map(
            (i) => presets[i]
          );

          onSave(selectedPresets);*/
          close();
        }}
      >
        <p>{t("opendash:widgets.catalogue.description")}</p>
        <Input.Search
          placeholder={t("opendash:widgets.catalogue.filter_widgets")}
          onSearch={(value) => {
            setFilter(value);
          }}
          onChange={(e) => {
            setFilter(e.target.value);
          }}
          style={{ width: "100%" }}
        />
        <div style={{ height: "70vh", overflowY: "scroll" }}>
          {Object.keys(getGroupedPresets)
            .sort((a, b) => {
              let indexA = presetTagOrder.indexOf(a);
              let indexB = presetTagOrder.indexOf(b);
              indexA = indexA === -1 ? Number.MAX_SAFE_INTEGER : indexA;
              indexB = indexB === -1 ? Number.MAX_SAFE_INTEGER : indexB;
              return indexA - indexB;
            })
            .map((key) => {
              return (
                <div key={key}>
                  <Divider
                    orientation="left"
                    style={{
                      fontSize: "22px",
                      fontWeight: "bold",
                      color: "var(--ant-primary-color)",
                    }}
                  >
                    {t("opendash:widgets.catalogue.category." + key)}
                  </Divider>
                  <CardList
                    style={{
                      textAlign: "left",
                      whiteSpace: "nowrap",
                      overflowY: "hidden",
                      overflowX: "auto",
                      width: "100%",
                    }}
                  >
                    {getGroupedPresets[key]
                      .filter((item) => {
                        const title = t(item.label);
                        const description = t(item.description);
                        return (
                          title
                            .toLocaleLowerCase()
                            .indexOf(filter.toLocaleLowerCase()) !== -1 ||
                          description
                            .toLocaleLowerCase()
                            .indexOf(filter.toLocaleLowerCase()) !== -1
                        );
                      })
                      .map((item, i) => (
                        <CardListItem
                          key={i}
                          style={{
                            display: "inline-block",
                            marginRight: "10px",
                            height: "407px",
                          }}
                        >
                          <WidgetPresetComponent
                            item={item}
                            onAdd={(presets: WidgetPresetInterface[]) => {
                              if (onSave) {
                                onSave(presets);
                              }
                              close();
                            }}
                          ></WidgetPresetComponent>
                        </CardListItem>
                      ))}
                  </CardList>
                </div>
              );
            })}
        </div>
      </Modal>
    );
  }
);
